import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';

export const FreehandElementSchema = BaseElementSchema.extend({
  type: z.literal('freehand'),
  data: z.object({
    pathData: z.string(),
  }),
});
